$bog_smalljs_landing $mol_view
	arch_label_workspace @ \workspace
	arch_label_registry @ \registry
	arch_label_framework @ \the framework
	arch_label_package @ \your package
	arch_label_registry_own @ \your registry
	arch_label_project @ \your project
	arch_label_entry @ \entry point
	arch_label_tree @ \the markup
	sub /
		<= Hero $mol_view
			sub /
				<= Hero_head $mol_view
					sub /
						<= Hero_eyebrow $mol_view
							sub /
								<= Hero_eyebrow_text @ \Reactive micromodules
						<= Hero_title $mol_view
							dom_name \h1
							sub /
								<= Hero_title_pre @ \$mol — the reactive
								<= Hero_title_accent $mol_view
									dom_name \span
									sub /
										<= Hero_title_accent_text @ \micromodule
								<= Hero_title_post @ \ framework
						<= Hero_subtitle $mol_view
							sub /
								<= Hero_subtitle_text @ \Reactivity lives in the framework's foundation, not bolted on top.
						<= Hero_subtitle_note $mol_view
							sub /
								<= Hero_subtitle_note_text @ \Dependency arrays, manual subscriptions, manual cache invalidation, effect cleanup — none of it exists here. Not made easier, made unnecessary.
						<= Hero_actions $mol_view
							sub /
								<= Hero_cta_start $mol_link
									arg *
										section \docs
										page \getting-started
									sub /
										<= Hero_cta_start_label @ \Get Started
										<= Hero_cta_start_icon $mol_icon_arrow_right
								<= Hero_cta_play $mol_link
									arg *
										section \playground
										page null
									sub /
										<= Hero_cta_play_label @ \Try Playground
										<= Hero_cta_play_icon $mol_icon_open_in_new
								<= Hero_cta_why $mol_link
									arg *
										section \docs
										page \introduction
									sub /
										<= Hero_cta_why_label @ \Why $mol
										<= Hero_cta_why_icon $mol_icon_arrow_right
				<= Signature $mol_view
					sub /
						<= Sign_panel $mol_view
							sub /
								<= Sign_code $mol_view
									sub /
										<= Sign_code_label $mol_view
											sub /
												<= Sign_code_label_text @ \view.tree
										<= Sign_code_view $bog_smalljs_text_code
											text <= code \
											lang \tree
											sidebar_showed false
											playground_showed false
											run_enabled false
										<= Sign_ts_label $mol_view
											sub /
												<= Sign_ts_label_text @ \view.ts
										<= Sign_ts_view $bog_smalljs_text_code
											text <= code_ts \
											lang \ts
											sidebar_showed false
											playground_showed false
											run_enabled false
										<= Sign_css_label $mol_view
											sub /
												<= Sign_css_label_text @ \view.css.ts
										<= Sign_css_view $bog_smalljs_text_code
											text <= code_css \
											lang \ts
											sidebar_showed false
											playground_showed false
											run_enabled false
								<= Sign_arrow $mol_view
									sub /
										<= Sign_arrow_text \→
								<= Sign_live $mol_view
									sub /
										<= Sign_live_label $mol_view
											sub /
												<= Sign_live_label_text @ \live
										<= Sign_demo $bog_smalljs_demo
						<= Sign_caption $mol_view
							sub /
								<= Sign_caption_text @ \Three files: the markup, the logic and the styles.
						<= Sign_try $mol_link
							arg *
								section \playground
								page null
								sample \hello
							sub /
								<= Sign_try_label @ \Try this example
								<= Sign_try_icon $mol_icon_open_in_new
		<= Features $mol_view
			sub /
				<= Feature1 $mol_view
					sub /
						<= Feature1_title $mol_view
							sub /
								<= Feature1_title_text @ \Minimalistic
						<= Feature1_text $mol_text
							text @ \An incrementally adoptable ecosystem that scales between a single component and a full-stack local-first app.
				<= Feature2 $mol_view
					sub /
						<= Feature2_title $mol_view
							sub /
								<= Feature2_title_text @ \Optimal
						<= Feature2_text $mol_text
							text @ \Build UIs as trees of components. Reactivity is automatic, side-effects are explicit.
				<= Feature3 $mol_view
					sub /
						<= Feature3_title $mol_view
							sub /
								<= Feature3_title_text @ \Lazy
						<= Feature3_text $mol_text
							text @ \Full rendering virtualization — components outside the viewport simply do not exist.
		<= Arch $mol_view
			sub /
				<= Arch_eyebrow $mol_view
					sub /
						<= arch_eyebrow_text @ \Structure
				<= Arch_title $mol_view
					dom_name \h2
					sub /
						<= arch_title_text @ \Micromodule architecture by default
				<= Arch_line $mol_view
					sub /
						<= arch_line_text @ \A project is a folder, a folder is a repository, and the framework sits next to your code instead of inside it. The layout is the same for a first component and for a company with thirty of them.
				<= Arch_structure $bog_smalljs_structure
					tree <= arch_tree \
					steps_showed true
				<= Arch_link $mol_link
					arg *
						section \docs
						page \structure
					sub /
						<= arch_link_label @ \How a project is laid out
						<= Arch_link_icon $mol_icon_arrow_right
		<= Versus $mol_view
			sub /
				<= Versus_eyebrow $mol_view
					sub /
						<= versus_eyebrow_text @ \Compare
				<= Versus_line $mol_view
					sub /
						<= versus_line_text @ \One scenario, run side by side in React, Vue and $mol, live in your own browser.
				<= Versus_links $mol_view
					sub /
						<= Versus_open $mol_link
							arg *
								section \versus
								page null
							sub /
								<= versus_open_label @ \Open the comparison
								<= Versus_open_icon $mol_icon_arrow_right
						<= Versus_pair $mol_link
							arg *
								section \versus
								a \mol
								b \react
								page null
							sub /
								<= versus_pair_label @ \Start with $mol vs React
		<= Footer $mol_view
			sub /
				<= Footer_cols $mol_view
					sub /
						<= Footer_col1 $mol_view
							sub /
								<= Footer_sect_docs $mol_view
									sub /
										<= Footer_sect_docs_title $mol_view
											sub /
												<= Footer_sect_docs_title_text @ \Docs
										<= Footer_link_quickstart $mol_link
											title @ \Quick Start
											arg *
												section \docs
												page \getting-started
										<= Footer_link_guide $mol_link
											title @ \Guide
											arg *
												section \docs
												page \views
										<= Footer_link_tutorial $mol_link
											title @ \Tutorial
											arg *
												section \course
												page \
										<= Footer_link_examples $mol_link
											title @ \Examples
											arg *
												section \docs
												page \showcase
										<= Footer_link_api $mol_link
											title @ \API
											arg *
												section \docs
												page \api-mol-string
						<= Footer_col2 $mol_view
							sub /
								<= Footer_sect_about $mol_view
									sub /
										<= Footer_sect_about_title $mol_view
											sub /
												<= Footer_sect_about_title_text @ \About
										<= Footer_link_faq $mol_link
											title @ \FAQ
											arg *
												section \docs
												page \faq
										<= Footer_link_team $mol_link
											title @ \Team
											arg *
												section \docs
												page \team
										<= Footer_link_releases $mol_link
											title @ \Releases
											arg *
												section \docs
												page \releases
						<= Footer_col3 $mol_view
							sub /
								<= Footer_sect_resources $mol_view
									sub /
										<= Footer_sect_resources_title $mol_view
											sub /
												<= Footer_sect_resources_title_text @ \Resources
										<= Footer_link_playground $mol_link
											title @ \Playground
											arg *
												section \playground
												page \
										<= Footer_link_course $mol_link
											title @ \Course
											arg *
												section \course
												page \
										<= Footer_link_ui $mol_link
											title @ \UI Components
											uri \https://mol.hyoo.ru/#!section=demos
											target \_blank
										<= Footer_link_telegram $mol_link
											title @ \Telegram
											uri \https://t.me/giper_dev
											target \_blank
										<= Footer_link_dev $mol_link
											title @ \DEV Community
											uri \https://dev.to/t/mol
											target \_blank
						<= Footer_col4 $mol_view
							sub /
								<= Footer_sect_libs $mol_view
									sub /
										<= Footer_sect_libs_title $mol_view
											sub /
												<= Footer_sect_libs_title_text @ \Official Libraries
										<= Footer_link_wire $mol_link
											title @ \$mol_wire
											uri \https://github.com/hyoo-ru/mam_mol/tree/master/wire
											target \_blank
										<= Footer_link_fetch $mol_link
											title @ \$mol_fetch
											uri \https://github.com/hyoo-ru/mam_mol/tree/master/fetch
											target \_blank
										<= Footer_link_compare $mol_link
											title @ \$mol_compare_deep
											uri \https://github.com/hyoo-ru/mam_mol/tree/master/compare/deep
											target \_blank
										<= Footer_link_router $mol_link
											title @ \$mol_state_arg
											uri \https://github.com/hyoo-ru/mam_mol/tree/master/state/arg
											target \_blank
										<= Footer_link_crowd $mol_link
											title @ \$hyoo_crowd
											uri \https://github.com/hyoo-ru/crowd.hyoo.ru
											target \_blank
										<= Footer_link_baza $mol_link
											title @ \Giper Baza
											uri \https://github.com/giper-dev/baza
											target \_blank
				<= Footer_copy $mol_view
					sub /
						<= Footer_copy_line1 $mol_view
							sub /
								<= Footer_copy_line1_text @ \Released under the MIT License.
						<= Footer_copy_line2 $mol_view
							sub /
								<= Footer_copy_line2_text @ \Copyright © 2026 smalljs
